import * as Sentry from "@sentry/react";

const initSentry = () => {
  const isProduction =  process.env.environment === "production" || process.env.REACT_APP_STAGE === "prod";
  const sentryDSN = process.env.REACT_APP_SENTRY_DSN;

  if (!sentryDSN) {
    console.warn("Sentry DSN not configured. Error tracking disabled.");
    return;
  }

  Sentry.init({
    dsn: sentryDSN,
    environment: process.env.environment || process.env.REACT_APP_STAGE || "development",
    enabled: isProduction || process.env.REACT_APP_SENTRY_ENABLED === "true",
    // Performance Monitoring
    integrations: [
      Sentry.browserTracingIntegration(),
    ],

    tracesSampleRate: 1.0,

    // Capture Replay for 10% of all sessions,
    // plus, capture 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // Additional config
    beforeSend(event, hint) {
      // Filter out certain errors if needed
      if (event.exception) {
        const error = hint.originalException;
        const errorMsg = error?.message || event.message || '';
        const errorStack = error?.stack || '';

        // Skip errors from browser extensions or malicious scripts
        if (errorStack.includes("chrome-extension://")) {
          return null;
        }

        // Skip WebKit bridge errors (iOS/Android WebView)
        if (errorMsg.includes("window.webkit") || errorStack.includes("window.webkit")) {
          return null;
        }

        // Skip messageHandlers errors
        if (errorMsg.includes("messageHandlers") || errorStack.includes("messageHandlers")) {
          return null;
        }
      }

      return event;
    },

    ignoreErrors: [
      // Browser extensions
      "chrome-extension://",
      "moz-extension://",
      "Invalid call to runtime.sendMessage",
      "Tab not found",
      // Random plugins/extensions
      "top.GLOBALS",
      // Random network errors
      "NetworkError",
      "Network request failed",
      // Random player errors
      "player.vimeo.com",
      "UnknownError",
      // WebKit bridge errors (iOS/Android WebView)
      "window.webkit",
      "messageHandlers",
      "webkit.messageHandlers",
    ],
  });
};

export default initSentry;
